import { IconProps, iconA11yProps } from '../types';

export const Polls = ({ classNames, label }: IconProps) => (
    <svg
        className={classNames}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...iconA11yProps(label)}
    >
        <circle cx="5.5" cy="18" r="1.5" />
        <path d="M11 18L20 18" />
        <circle cx="5.5" cy="12" r="1.5" />
        <path d="M11 12L20 12" />
        <circle cx="5.5" cy="6" r="1.5" />
        <path d="M11 6L20 6" />
    </svg>
);
